import { ORDERS } from '@perpay-web/fintech/constants/tableNames';

export const getOrderEntity = (state, orderUUID) => {
    if (!state.entities[ORDERS]) {
        return null;
    }
    return state.entities[ORDERS][orderUUID];
};

export const getOrderTotal = (state, orderUUID) => {
    const order = getOrderEntity(state, orderUUID);
    return order ? order.checkout.summary.total : null;
};

export const getOrderCredit = (state, orderUUID) => {
    const order = getOrderEntity(state, orderUUID);
    return order ? order.credit : null;
};
